module.exports = {"511822100":"严道镇","511822101":"花滩镇","511822102":"龙苍沟镇","511822103":"牛背山镇","511822104":"新添镇","511822200":"六合乡","511822201":"烈太乡","511822202":"安靖乡","511822203":"民建彝族乡","511822204":"烈士乡","511822205":"荥河乡","511822206":"新建乡","511822207":"泗坪乡","511822208":"新庙乡","511822210":"大田坝乡","511822211":"天凤乡","511822212":"宝峰彝族乡","511822214":"附城乡","511822215":"五宪乡","511822216":"烟竹乡","511822217":"青龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511822.json
// module id = 2382
// module chunks = 0